import {
  GET_ALL_EVENTS,
  SET_SINGLE_EVENT,
  REMOVE_SINGLE_EVENT,
  SET_SINGLE_SECTION,
  SET_EVENT_SECTIONS,
  ADD_EVENT_SECTION,
  REMOVE_EVENT_SECTION,
  SET_SECTION_TICKETS,
  REMOVE_SECTION_TICKET,
  SET_EVET_TICKET_TOKEN_LIST,
  SET_SINGLE_WGEVENT,
  GET_ACTIVE_WGEVENT,
} from "../../@jumbo/constants/ActionTypes";

export const setAllEvents = (events) => {
  return (dispatch) => {
    dispatch({
      type: GET_ALL_EVENTS,
      payload: events,
    });
  };
};

export const setEventSecitons = (sections) => {
  return (dispatch) => {
    dispatch({
      type: SET_EVENT_SECTIONS,
      payload: sections,
    });
  };
};

export const setSigleEvent = (event) => {
  return (dispatch) => {
    dispatch({
      type: SET_SINGLE_EVENT,
      payload: event,
    });
  };
};

export const removeEvent = (eventId) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_SINGLE_EVENT,
      payload: eventId,
    });
  };
};

export const setSingleSection = (eventSection) => {
  return (dispatch) => {
    dispatch({
      type: SET_SINGLE_SECTION,
      payload: eventSection,
    });
  };
};

export const addSingleEventSection = (eventSection) => {
  return (dispatch) => {
    dispatch({
      type: ADD_EVENT_SECTION,
      payload: eventSection,
    });
  };
};

export const removeEventSeciton = (eventId) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_EVENT_SECTION,
      payload: eventId,
    });
  };
};

export const setSectionTickets = (sectionTickets) => {
  return (dispatch) => {
    dispatch({
      type: SET_SECTION_TICKETS,
      payload: sectionTickets,
    });
  };
};

export const removeTicket = (ticketId) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_SECTION_TICKET,
      payload: ticketId,
    });
  };
};

export const setEvenTicketTokenList = (list) => {
  return (dispatch) => {
    dispatch({
      type: SET_EVET_TICKET_TOKEN_LIST,
      payload: list,
    });
  };
};

export const setSingleWGEvent = (event) => {
  return (dispatch) => {
    dispatch({
      type: SET_SINGLE_WGEVENT,
      payload: event,
    });
  };
};

export const settActiveWGEvent = (event) => {
  return (dispatch) => {
    dispatch({
      type: GET_ACTIVE_WGEVENT,
      payload: event,
    });
  };
};
